<script setup lang="ts">
import SliderModelImport from '~/components/slider-model-new/SliderModelNew.vue';
defineProps({
  photos: {
    type: Array as () => string[],
    default: () => [],
  },
  indexViewImage: {
    type: Number,
    default: 0,
  },
});
defineEmits(['close']);
</script>

<template>
  <div class="review-slider-wrapper">
    <SliderModelImport
      :images="photos"
      name="SliderReviews"
      :index-view-image="indexViewImage"
      is-reviews
      @close="$emit('close')"
    />
  </div>
</template>

<style scoped lang="scss">
.review-slider-wrapper {
  width: 100vw;
  height: 100vh;
}
</style>
